<ngx-loading-bar color="#FFFF00" height="5px"></ngx-loading-bar>
<div class="row">
  <div class="col-sm-12">
    <app-card>
        <div class="table-responsive ng-tns-c94-73">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover" data-page-length='10'>
          <thead>
          <tr>
            <th><span>Lab Name</span></th>
            <th><span>Package Name</span></th>
            <th><span>Number OF testing</span></th>
            <th><span>Lab Price</span></th>
            <th><span>Our Price</span></th>
            <th><span>Status</span></th>
            <th><span>Action</span></th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let val of getPackageList">
              <td>{{ val.lab[0].name }}</td>
              <td>{{ val.name }}</td>
              <td>{{ val.testingList.length  }}</td>
              <td>
                <h5><span _ngcontent-lxe-c118="" class="badge m-r-6 badge-pill badge-warning ng-tns-c85-32">{{ val.labPrice }}</span></h5>
              </td>
              <td>
                <h5><span _ngcontent-lxe-c118="" class="badge m-r-6 badge-pill badge-success ng-tns-c85-32">{{ val.price }}</span></h5>
              </td>
              <td>{{ val.status }}</td>
              <td>
                <button type="button" class="btn btn-icon btn-dark ng-tns-c85-29">
                  <i _ngcontent-khb-c116="" [routerLink]="['/EditPackage/',val._id]" class="feather icon-edit"></i>
                </button>
                <button type="button" style="margin-left: 10px;" class="btn btn-icon btn-danger ng-tns-c85-29" (click)="deletePackage(val._id)">
                  <i _ngcontent-khb-c116="" class="feather icon-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
    </app-card>
  </div>
</div>
